exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__news-header-card___UjZ_V{position:relative;display:flex;flex-flow:column;width:450px;height:100%}", ""]);

// exports
exports.locals = {
	"news-header-card": "styles__news-header-card___UjZ_V"
};